var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { ContentNode } from './content-node';
var cls = classNames('empty-tout');
export var ManageToutDefaultProps = {
  defaultText: 'Click here to provide more details'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: ", ";\n    font-family: ", ";\n    border: 2px dashed ", "77;\n    color: ", "CC;\n    border-radius: ", ";\n    box-sizing: border-box;\n    user-select: none;\n    b, strong {\n      color: ", ";\n    }\n  "], ["\n    width: 100%;\n    font-size: ", ";\n    font-family: ", ";\n    border: 2px dashed ", "77;\n    color: ", "CC;\n    border-radius: ", ";\n    box-sizing: border-box;\n    user-select: none;\n    b, strong {\n      color: ", ";\n    }\n  "])), theme.FONT_SIZE(15), theme.FONT('serif'), theme.COLOR('strong-chrome'), theme.COLOR('strong-chrome'), theme.UNIT(3), theme.COLOR('text-chrome'))
});
var BorderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: 1px solid transparent;\n    border-radius: ", ";\n  "], ["\n    border: 1px solid transparent;\n    border-radius: ", ";\n  "])), theme.UNIT(2.5))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", ";\n    background: ", ";\n    border-radius: ", ";\n    font-family: inherit;\n  "], ["\n    padding: ", ";\n    background: ", ";\n    border-radius: ", ";\n    font-family: inherit;\n  "])), theme.UNIT(4), theme.COLOR('canvas'), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  NAME: 'ManageTout',
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Border: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), BorderStyles),
  Content: styled(ContentNode)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var ManageTout = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, ManageToutDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    onClick = componentProps.onClick,
    defaultText = componentProps.defaultText;
  var content = ((_a = componentProps.content) === null || _a === void 0 ? void 0 : _a.text) ? componentProps.content : {
    text: defaultText
  };
  return React.createElement(My.Container, {
    onClick: onClick,
    className: cls.name(className)
  }, React.createElement(My.Border, null, React.createElement(My.Content, {
    entity: content
  })));
};
ManageTout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;